module.exports = __webpack_public_path__ + "img/video.371f53de.png";